export interface IBankAccount {
  id: number
  name: string
  glAccountNo: string
  type: string
  glBalance?: number
}

export interface IWireBlotterRow {
  id: number
  wireDate: string | null
  direction: string
  counterparty: string
  loanId: string
  amount: number
  purpose: string
  signedAmount?: number
}

export const BANK_ACCOUNT_TYPES = ['Operating', 'Clearing', 'Custodial', 'Payroll', 'Other']

export const WIRE_DIRECTIONS = ['IN', 'OUT']

export const emptyBankAccount = (): Partial<IBankAccount> => ({
  name: '',
  glAccountNo: '',
  type: 'Operating',
})

export const emptyWireBlotterRow = (): Partial<IWireBlotterRow> => ({
  wireDate: '',
  direction: 'OUT',
  counterparty: '',
  loanId: '',
  amount: 0,
  purpose: '',
})
